export function ensureTrailingSlash(url) {
  if (!url) return url;
  return url.endsWith('/') ? url : `${url}/`;
}

export function removeTrailingSlash(url) {
  if (!url) return url;
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

export function normalizeUrl(url, addSlash = true) {
  if (!url || url.length === 1) return url;
  return addSlash ? ensureTrailingSlash(url) : removeTrailingSlash(url);
}